import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { contactRequestsQueryKey } from "./useListContactRequestsQuery";
import {
  SampleRequestService,
  BooleanResponse,
  ContactSupplierRequest,
  ApiError,
} from "../api/public";

export const useContactSupplierMutation = (
  options?: UseMutationOptions<
    BooleanResponse,
    ApiError,
    ContactSupplierRequest,
    string
  >
) => {
  const queryClient = useQueryClient();
  return useMutation(SampleRequestService.sampleRequestContactSupplier, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(contactRequestsQueryKey());
      options?.onSuccess?.(data, variables, context);
    },
  });
};
